module.exports = __webpack_public_path__ + "img/bigdata_bg.8ec398d1.png";